import { connect } from 'react-redux';

import { RootState } from 'state/reducers';
import { signInActions, selectPending, selectErrors } from 'state/signIn';

import SignInPage from './SignInPage';

const { SIGN_IN_REQUEST } = signInActions;

const mapStateToProps = (state: RootState) => ({
  pending: selectPending(state),
  errors: selectErrors(state),
});

const mapDispatchToProps = {
  signIn: SIGN_IN_REQUEST,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignInPage);
